import { Grid } from '@material-ui/core';
import { FormikWriteInput } from 'components/Forms/Inputs/TextInputs/FormikWriteInput';
import { getRestResourceFormDrawer } from 'components/Forms/RestResourceFormDrawer';
import { FormikProps } from 'formik';
import { getYupStringValidation } from 'libs/yup';
import React, { createRef, PureComponent, ReactNode } from 'react';
import { fdw } from 'utils/configs/drawerWidths';
import { setFormInitialValue } from 'utils/functions/setFormInitialValue';
import { rrc } from 'utils/strings/resourceClasses';
import * as yup from 'yup';

import { IProps } from './MyOrganizationForm.container';

export interface IOrganizationFormValues {
  name: string;
  comment: string;
}

export type IOrganizationRequestParams = IOrganizationFormValues;

const RestResourceFormDrawer = getRestResourceFormDrawer<IOrganizationFormValues, IOrganizationRequestParams>();

export class MyOrganizationForm extends PureComponent<IProps> {
  private formFocusRef = createRef<HTMLInputElement>();

  public render(): ReactNode {
    return (
      <RestResourceFormDrawer
        renderForm={this.renderForm()}
        formFocusRef={this.formFocusRef}
        getInitialFormValues={this.getInitialFormValues}
        getValidationSchema={this.getValidationSchema}
        formDrawerWidth={fdw.small}
        resourceClass={rrc.organization}
      />
    );
  }

  public renderForm = () => {
    return (formikProps: FormikProps<IOrganizationFormValues>): ReactNode => {
      return (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormikWriteInput field={'name'} formikProps={formikProps} required inputRef={this.formFocusRef} />
          </Grid>
          <Grid item xs={12}>
            <FormikWriteInput field={'comment'} formikProps={formikProps} multiline />
          </Grid>
        </Grid>
      );
    };
  };

  private getInitialFormValues = (): IOrganizationFormValues => {
    const { organizationToEdit } = this.props;

    return {
      name: setFormInitialValue(organizationToEdit, 'name'),
      comment: setFormInitialValue(organizationToEdit, 'comment'),
    };
  };

  private getValidationSchema = (): yup.ObjectSchema<IOrganizationFormValues> => {
    return yup.object().shape({
      name: getYupStringValidation(true),
      comment: getYupStringValidation(),
    }) as yup.ObjectSchema<IOrganizationFormValues>;
  };
}
